import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-reddi-graph-legend',
  templateUrl: './reddi-graph-legend.component.html',
  styleUrls: ['./reddi-graph-legend.component.scss'],
  standalone: false,
})
export class ReddiGraphLegendComponent {
  @Input() showTitle: boolean = false
  @Input() showReportLegend: boolean = true
  _size: number = 20
  _icon_detection: string = 'wifi'
  _icon_imitation: string = 'autorenew'
  _icon_hand: string = 'touch_app'
}
